import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const items = [{
    title: 'El Manual Maestro "El Reinicio de 72 Horas"',
    desc: 'PDF de lectura rápida, sin relleno teórico.'
  }, {
    title: 'Protocolos de Micro-Recuperación Neural',
    desc: 'Ejercicios de 3 minutos para calmar tu sistema nervioso.'
  }, {
    title: 'La Hoja de Ruta',
    desc: 'Qué hacer exactamente el Día 1, Día 2 y Día 3.'
  }, {
    title: 'El Inventario de Fugas',
    desc: 'Cómo identificar qué te está robando la energía hoy.'
  }, {
    title: 'El Plan de Crisis "Botón de Pánico"',
    desc: 'Para momentos de colapso inminente.'
  }, {
    title: 'Guía de Límites',
    desc: 'Cómo decir NO sin dar explicaciones extenuantes.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-141">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-142">
        <h2 className="text-3xl md:text-4xl font-serif text-teal text-center mb-16" data-id="element-143">
          Lo que obtienes hoy
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-144">
          {items.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-sage/50 hover:shadow-md transition-shadow" data-id="element-145">
              <CheckCircle2 className="w-8 h-8 text-gold mb-4" data-id="element-146" />
              <h3 className="text-xl font-serif text-teal mb-2" data-id="element-147">
                {item.title}
              </h3>
              <p className="text-charcoal/80" data-id="element-148">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}